import { render } from "./SocialConservation.vue?vue&type=template&id=2729b23e&ts=true"
import script from "./SocialConservation.vue?vue&type=script&lang=ts"
export * from "./SocialConservation.vue?vue&type=script&lang=ts"

import "./SocialConservation.vue?vue&type=style&index=0&id=2729b23e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__